import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const BottomWrapper = styled(Flexbox)`
  min-height: 0;
`;
